export default {
  notifications: [],
  activeMenus: [],
  activeoption: '',
  sidebar: true,
  loading: false
}
